import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import variables from '../../common/variables';
import styles from '../styles';
import fabric from '../../common/fabric';
import useOnScreen from '../../common/hooks/useOnScreen';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import embedActions from '../actions/embedActions';

const Styles = styled.div`
  border: ${props =>
    props.currentSlide
      ? `2px solid ${variables.colors.orange}`
      : '2px solid rgba(78, 86, 255, 0.1)'};
  box-shadow: 0px 5px 8px -2px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  margin: 10px;
  border-radius: 5px;
  padding: 0px;
  width: 109px;
  cursor: pointer;
  :hover {
    border-color: ${props =>
      props.currentSlide ? variables.colors.orange : `rgba(78, 86, 255, 1)`};
  }
`;

const CardIndex = styled.div`
  position: absolute;
  bottom: 2px;
  left: 3px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  padding: 2px 3px;
  border-radius: 3px;
  font-weight: 700;
  width: auto;
  font-size: 10px;
`;

const SlideThumb = props => {
  const [src, setSrc] = React.useState();
  const ref = React.useRef();
  const onScreen = useOnScreen(ref);

  const renderedJSON = React.useRef();

  const loadFromJSON = (json, slideIndex, callback) => {
    const thumbHeight = 310;
    const ratio = thumbHeight / window.documentSize.height;
    const thumbWidth = Math.ceil(window.documentSize.width * ratio);

    const thumbCanvas = new fabric.StaticCanvas(slideIndex.toString(), {
      width: thumbWidth,
      height: thumbHeight,
    });

    thumbCanvas.setZoom(ratio);

    const generateThumb = thumbCanvas => {
      const data = thumbCanvas.toDataURL({
        format: 'jpg',
        multiplier: 1,
        quality: 0.85,
      });

      if (slideIndex === 0) {
        props.actions.dispatchThumbnailGenerated(data);
      }

      setSrc(data);

      callback && callback();
    };

    thumbCanvas.on('object:allImagesRendered', () => {
      generateThumb(thumbCanvas);
    });

    try {
      thumbCanvas.loadFromJSON(json, () => {
        generateThumb(thumbCanvas);
      });
    } catch (e) {
      console.error('Error generating thumbnail', e.message, slideIndex);
    }
  };

  React.useEffect(() => {
    const jsonAsString = JSON.stringify(props.json);
    if (
      (onScreen || props.index === 0) &&
      (!src || renderedJSON.current !== jsonAsString)
    ) {
      loadFromJSON(props.json, props.index);
      renderedJSON.current = jsonAsString;
    }
  }, [props.json, props.index, onScreen, src]);

  return (
    <Styles currentSlide={props.currentSlide === props.index}>
      <div
        ref={ref}
        style={{
          position: 'relative',
          height: '61px',
          border: '2px solid #ffffff7a',
          borderRadius: '3px',
          overflow: 'hidden',
          backgroundColor: 'var(--panelColor)',
        }}
        onClick={() => {
          props.actions.dispatchGoToSlide(props.index, false);
        }}
      >
        <CardIndex>{props.index + 1}</CardIndex>
        {src ? (
          <img
            style={styles.slidesListThumbnails}
            src={src}
            alt={`Slide ${props.index + 1}`}
          />
        ) : (
          <div style={styles.slidesListThumbnails} />
        )}
      </div>
    </Styles>
  );
};

SlideThumb.propTypes = {
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  index: PropTypes.number.isRequired,
  json: PropTypes.object,
  currentSlide: PropTypes.number,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(embedActions, dispatch),
});

const mapStateToProps = (state, props) => ({
  currentSlide: state.slideReducer.index,
  totalSlides: state.slideReducer.slides.length,
  slides: state.slideReducer.slides,
});

export default connect(mapStateToProps, mapDispatchToProps)(SlideThumb);
